import { Container } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet'

import { StatsLoader } from '../../Contexts'
import WorldBasePage from '../WorldBasePage'
import Details from './Details'

const StatsPage: React.FC = () => {
  return (
    <WorldBasePage>
      <Helmet title="XYO World Stats" />
      <Container>
        <StatsLoader>
          <Details />
        </StatsLoader>
      </Container>
    </WorldBasePage>
  )
}

export default StatsPage
